import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import store from "./smarter-power/store/index.js";
import SPMainMenu from "./smarter-power/components/SPMainMenu.vue";
import SPSidebarMenu from "./smarter-power/components/SPSidebarMenu.vue";
import Accordion from "./smarter-power/components/Accordions.vue";
import SummaryPanelFeedback from "./smarter-power/components/SummaryPanelFeedback.vue";
// import vmodal from "vue-js-modal";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

import smarterPower from "../scss/smarter-power.scss";
require("./components/smarterpower-filter.js"); //  TODO:  convert to vue

// Vue.use(vmodal);
Vue.use(LottieVuePlayer);

/**
 * Set up config
 * **/
function init() {
  new Vue({
    el: "#smarter-power-app",
    components: {
      "sp-menu": SPMainMenu,
      "sp-sidebar-menu": SPSidebarMenu,
      Accordion,
      "summary-panel-feedback": SummaryPanelFeedback,
    },
    store,
    computed: {
      ...mapFields(["mainMenuVisible"]),
    },
    methods: {
      toggleMainMenu() {
        this.mainMenuVisible = !this.mainMenuVisible;
      },
    },
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});
